import React, { Fragment } from "react";
import { Urls } from "../../constants/UrlConstants";
import styles from "../../assets/css/modules/shared/cookie-bar.css";

export default {
  heading: {
    Any: "Looking for AXA PPP healthcare?",
    HOL: "We’re becoming AXA Health",
    HOLMOL: "Welcome to AXA Health"
  },
  description: {
    Any: (
      <Fragment>
        <p>
          Don’t worry you're in the right place. We're bringing all of our
          health brands together under one name: AXA Health. We'll still be the
          health partner you can rely on and in future you'll see new ways in
          which we can help you with your wellbeing, fitness and mental health.
        </p>
        <p>
          You'll start to see AXA Health in our communications, website and
          email addresses. And when you call us, we'll answer as AXA Health too
          - we're still the same friendly team, with the same expertise.
        </p>
        <p>
          For a while, you may see both AXA PPP healthcare and AXA Health on
          your documents and our{" "}
          <a
            className={styles.infolink}
            href={Urls.AxaHealthLegal}
            target="_blank"
            rel="noreferrer noopener"
          >
            legal information
          </a>{" "}
          on the website can explain more.
        </p>
      </Fragment>
    ),
    HOL: (
      <Fragment>
        <p>
          We're bringing all of our health brands together under one name: AXA
          Health. We'll still be the health partner you can rely on and in
          future you'll see new ways in which we can help you with your
          wellbeing, fitness and mental health.
        </p>
        <p>
          You'll start to see AXA Health in our communications, website and
          email addresses. And when you call us, we'll answer as AXA Health too
          - we're still the same friendly team, with the same expertise.
        </p>
        <p>
          For a while, you may see Health-on-Line, AXA PPP healthcare and AXA
          Health on your documents and our information about AXA Health will
          explain more.
        </p>
      </Fragment>
    ),
    Saga: (
      <p>
        AXA Health is a trading name of AXA PPP healthcare Limited. Calls
        relating to any claims will be answered as AXA Health and you will see
        both AXA PPP healthcare Limited and AXA Health names and/or logos in
        your documentation, online and via email.
      </p>
    ),
    HOLMOL: (
      <p>
        You’ll find all your plan information here at Member Online. We
        recommend saving this page to your favourites, as it replaces the
        Health-on-Line Customer Online portal, where you may have previously
        accessed your information.
      </p>
    )
  },
  informationLink: {
    Any: (
      <p>
        <a
          href={Urls.AxaHealthAboutUs}
          target="_blank"
          rel="noreferrer noopener"
        >
          More about us
        </a>
      </p>
    ),
    HOL: (
      <p>
        <a
          href={Urls.AxaHealthHolAbout}
          target="_blank"
          rel="noreferrer noopener"
        >
          More about us
        </a>
      </p>
    )
  },
  buttonText: "Close"
};
